export default "export { TimePicker } from './TimePicker';\nexport type { TimePickerProps } from './TimePicker';\n";